import { AuthUtil } from "@/@auth/classes";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { User, UserType } from "..";

/**
 * The origin each user type belongs on. Taken from the env so it is correct in
 * every environment: `http://localhost:8033` in development,
 * `https://admin.equity4talent.com` in production.
 */
const appsBases: Record<UserType, string> = {
  founder: process.env.VUE_APP_BASE_URL_BUSINESS,
  talent: process.env.VUE_APP_BASE_URL_TALENT,
  admin: process.env.VUE_APP_BASE_URL_ADMIN,
};
/**
 *
 * @param to
 * @param from
 * @param next
 */
export const InNavigateRespectively = (
  user: User,
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  /**
   * Compare full origins rather than the first label of the hostname. Under
   * subdomains that label identified the app ("admin" of admin.e4t.com), but on
   * localhost every app is `localhost`, so no branch could ever match and the
   * guard redirected each app to itself forever.
   */
  const belongsHere = document.location.origin === appsBases[user.type];
  console.log("Going to ", document.location.origin, "expected", appsBases[user.type]);
  if (belongsHere) {
    next();
    return;
  }
  /**
   * If here redirect a user to where he/she belongs responsively
   */
  AuthUtil.redirectUser(user);
};
